module.exports = __webpack_public_path__ + "images/help/video-newtodo-ffe6845fbfce461ac91f1e8dd3fd7227.png";